import api from '@/api'

const namespaced = true

const state = {
  cycleTimes: [],
  cycleTimeFile: null
}

const getters = {
  cycleTimes: state => state.cycleTimes,
  cycleTimeFile: state => state.cycleTimeFile
}

const mutations = {
  SET_CYCLE_TIMES: (state, payload) => {
    state.cycleTimes = payload
  },
  SET_CYCLE_TIME_FILE: (state, payload) => {
    state.cycleTimeFile = payload
  }
}

const actions = {
  async fetchCycleTimes({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getCycleTimes(filter)

      if (data.error) {
        commit('SET_CYCLE_TIMES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_CYCLE_TIMES', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async downloadCycleTimes({ commit }, payload) {
    try {
      const filter = { ...payload }
      const response = await api.downloadCycleTime(filter)

      if (response.data.error) {
        commit('SET_CYCLE_TIME_FILE', null)
        return
      }

      commit('SET_CYCLE_TIME_FILE', response)
    } catch (err) {
      throw err
    }
  },
  resetFile({ commit }) {
    commit('SET_CYCLE_TIME_FILE', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
